import ImportarListaPreciosPage from "../pages/ImportarListaPreciosPage";

const routes = [
  {
    name: "ImportarListaPreciosPage",
    path: "/importar-lista-precios",
    component: ImportarListaPreciosPage,
    meta: {
      requiresAuth: true,
      permission: "LISTA_PRECIOS_PROVEEDOR_IMPORTAR",
    },
  },
];

export default routes;
